'use client';

const featureCards = [
  {
    icon: '🎯',
    text: (
      <>
        Converts <strong>high-intent website visitors</strong> in real time
      </>
    ),
  },
  {
    icon: '🏪',
    text: (
      <>
        Creates <strong>phygital, trust-led buying experiences</strong> at scale
      </>
    ),
  },
  {
    icon: '🔗',
    text: (
      <>
        Unifies <strong>sales, support, and advisory</strong> into one CX system
      </>
    ),
  },
  {
    icon: '🔄',
    text: (
      <>
        Builds a <strong>long-term engagement channel</strong> beyond the first purchase
      </>
    ),
  },
];

const lifecycleSteps = [
  {
    number: 1,
    title: 'Awareness & Acquisition',
    description: 'AI identifies and converts high-intent visitors in real time',
  },
  {
    number: 2,
    title: 'Phygital Purchase Experience',
    description: 'Trust-led buying journeys across digital and physical channels',
  },
  {
    number: 3,
    title: 'Unified Sales + Support',
    description: 'Sales, advisory, and support working as one CX system',
  },
  {
    number: 4,
    title: 'Post-Purchase Retention',
    description: 'Long-term engagement channel built beyond the first purchase',
  },
  {
    number: 5,
    title: 'LTV Maximisation',
    description: 'Repeat purchases, upsells, and loyalty compounding over time',
  },
];

export default function D2CGrowthSection() {
  return (
    <section
      style={{ background: '#1e2530' }}
      className="py-20 lg:py-28"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">

          {/* LEFT SIDE */}
          <div className="flex flex-col gap-6">

            {/* Top Label */}
            <div className="flex items-center gap-3">
              <div className="w-8 h-0.5" style={{ background: 'var(--color-accent)' }} />
              <span
                className="text-xs font-semibold uppercase tracking-widest"
                style={{ color: 'var(--color-accent)', fontFamily: "'Titillium Web', sans-serif" }}
              >
                D2C GROWTH
              </span>
            </div>

            {/* Main Heading */}
            <h2
              className="text-4xl sm:text-5xl font-bold leading-tight"
              style={{ color: '#ffffff', fontFamily: "'Titillium Web', sans-serif" }}
            >
              Accelerating D2C Growth
            </h2>

            {/* Description */}
            <p
              className="text-base sm:text-lg leading-relaxed max-w-md"
              style={{ color: 'rgba(255,255,255,0.65)' }}
            >
              UnifyMax optimizes the entire customer lifecycle from acquisition to lifetime value.
            </p>

            {/* Feature Cards */}
            <div className="flex flex-col gap-3 mt-2">
              {featureCards?.map((card, index) => (
                <div
                  key={index}
                  className="flex items-center gap-4 rounded-xl px-5 py-4"
                  style={{ background: '#2a3340' }}
                >
                  <div
                    className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center text-xl"
                    style={{ background: 'rgba(27,180,215,0.15)' }}
                  >
                    {card?.icon}
                  </div>
                  <p
                    className="text-sm sm:text-base leading-relaxed"
                    style={{ color: 'rgba(255,255,255,0.80)' }}
                  >
                    {card?.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Bottom Highlight Box */}
            <div
              className="rounded-xl px-6 py-5 mt-2"
              style={{
                background: '#252e3a',
                border: '1px solid rgba(27,180,215,0.3)',
              }}
            >
              <p
                className="text-sm sm:text-base leading-relaxed"
                style={{ color: 'rgba(255,255,255,0.65)' }}
              >
                Because when systems work in isolation, outcomes stay fragmented.{' '}
                <span
                  className="font-semibold"
                  style={{ color: 'var(--color-accent)' }}
                >
                  When they work together, growth becomes inevitable.
                </span>
              </p>
            </div>
          </div>

          {/* RIGHT SIDE — Lifecycle Card */}
          <div
            className="rounded-2xl p-6 sm:p-8"
            style={{
              background: '#252e3a',
              border: '1px solid rgba(255,255,255,0.08)',
            }}
          >
            {/* Card Title */}
            <p
              className="text-xs font-semibold uppercase tracking-widest mb-6"
              style={{ color: 'var(--color-accent)', fontFamily: "'Titillium Web', sans-serif" }}
            >
              CUSTOMER LIFECYCLE
            </p>

            {/* Steps */}
            <div className="flex flex-col gap-3">
              {lifecycleSteps?.map((step) => (
                <div
                  key={step?.number}
                  className="flex items-start gap-4 rounded-xl px-5 py-4"
                  style={{ background: '#2a3340' }}
                >
                  {/* Number Circle */}
                  <div
                    className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold"
                    style={{
                      background: 'var(--color-accent)',
                      color: '#ffffff',
                      fontFamily: "'Titillium Web', sans-serif",
                    }}
                  >
                    {step?.number}
                  </div>
                  {/* Text */}
                  <div>
                    <p
                      className="text-sm sm:text-base font-semibold leading-snug mb-1"
                      style={{ color: '#ffffff', fontFamily: "'Titillium Web', sans-serif" }}
                    >
                      {step?.title}
                    </p>
                    <p
                      className="text-xs sm:text-sm leading-relaxed"
                      style={{ color: 'rgba(255,255,255,0.55)' }}
                    >
                      {step?.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
